import { createSlice } from "@reduxjs/toolkit";

export interface UserInfo {
  email: string;
  id: string;
}
type UserMessageInRedis = {
  [campaignId: string]: {
    id: string;
    text: string;
    createdAt: any;
    status: string;
    // more: number;
  }[];
};
export interface UserMessageState {
  contactWithLastMessage: UserInfo[];
  userMessagesInRedis: UserMessageInRedis;
}

const initialState: UserMessageState = {
  contactWithLastMessage: [],
  userMessagesInRedis: {},

};

const UserMessageSlice = createSlice({
  name: "UserMessage",
  initialState,
  reducers: {
    setUserMessagesInRedisByCampaignId(state, action) {
      state.userMessagesInRedis = {
        ...state.userMessagesInRedis,
        ...action.payload, // Merge the new structure into the state
      };
    },

  },
});

export const {
  setUserMessagesInRedisByCampaignId
} = UserMessageSlice.actions;

export const userMessageActions = UserMessageSlice.actions;

export default UserMessageSlice.reducer;
